// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgUpload24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.4298 8.41942L12.4801 3.46967C12.1872 3.17678 11.7123 3.17678 11.4194 3.46967L6.46967 8.41942C6.17678 8.71231 6.17678 9.18718 6.46967 9.48008L6.54647 9.5472C6.84045 9.77094 7.26184 9.74856 7.53033 9.48008L11.25 5.758V15.5109C11.25 15.9251 11.5858 16.2609 12 16.2609C12.4142 16.2609 12.75 15.9251 12.75 15.5109V5.862L16.3692 9.48008C16.6621 9.77297 17.1369 9.77297 17.4298 9.48008C17.7227 9.18718 17.7227 8.71231 17.4298 8.41942ZM21 15.75C21 15.3358 20.6642 15 20.25 15L20.1482 15.0068C19.7822 15.0565 19.5 15.3703 19.5 15.75V19C19.5 19.2761 19.2761 19.5 19 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V15.75C4.5 15.3358 4.16421 15 3.75 15L3.64823 15.0068C3.28215 15.0565 3 15.3703 3 15.75V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V15.75Z"
				/>
			</Svg>
		);
	}
);
SvgUpload24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgUpload24;
